import { useEffect } from 'react';
import { fetcher } from '@shared/fetcher';
import { useUser } from '../authorization/use-user.ts';
import { useSearchParams } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { fcmAtom } from '@app/atoms/app/fcm.atom.ts';
import { appAtom } from '@app/atoms/app/app.atom.ts';
import { currentPlatform } from '@shared/const/platform.ts';

export function useBootstrap() {
  const [searchParams] = useSearchParams();
  const { fetchUser } = useUser();

  const setFcm = useSetAtom(fcmAtom);
  const setApp = useSetAtom(appAtom);
  useEffect(() => {
    const fcm = searchParams.get('fcm');
    if (fcm) {
      setFcm(fcm);
      localStorage.setItem('fcmToken', fcm);
    }

    const platform = currentPlatform();
    setApp((s) => ({ ...s, platform }));

    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      fetcher.defaults.headers.common['Authorization'] =
        `Bearer ${accessToken}`;
      fetchUser();
    }
  }, []);
}
